import { ILoginForm } from '@gamma/ui/forms';
import { Auth } from 'aws-amplify';
import { CognitoUserInterface } from '../../../shared/types/auth-types';

export const signIn = async ({ username, password }: ILoginForm) => {
  try {
    const user: CognitoUserInterface = await Auth.signIn(username, password);
    return user;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Unknown error');
  }
};
